// extracted by mini-css-extract-plugin
module.exports = {"green":"#00a259","darkGreen":"#00a259","hover":"#00a259","greenButton":"#00a259","grey":"#585858"};